const commonFn = {
  init(id) {
    return echarts.init(document.getElementById(id))
  }
}

export default commonFn



// WEBPACK FOOTER //
// ./src/assets/js/chart.js